export const getAvailabilityStoresSelector = state => state.bopisReducer.getAvailabilityStoresReducer;
